import { motion } from "framer-motion";
import { PROCESS } from "@/data/content";

export default function ProcessSection() {
  return (
    <section data-testid="process-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="eyebrow">/ 03 · How we work</div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tighter text-white">
            A four-phase engagement <span className="text-gradient">designed for outcomes.</span>
          </h2>
        </div>

        <div className="mt-14 relative">
          <div className="hidden md:block absolute left-0 right-0 top-[46px] h-px bg-gradient-to-r from-transparent via-cyan-400/40 to-transparent" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
            {PROCESS.map((p, i) => (
              <motion.div
                key={p.step}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.1 }}
                className="relative"
                data-testid={`process-step-${p.step}`}
              >
                <div className="glass rounded-2xl p-6 md:p-7 h-full">
                  <div className="flex items-center justify-between mb-6">
                    <span className="font-mono-plex text-xs tracking-[0.25em] text-cyan-300">
                      PHASE {p.step}
                    </span>
                    <span className="relative flex h-3 w-3">
                      <span className="absolute inset-0 rounded-full bg-cyan-400/40 animate-ping" />
                      <span className="relative m-auto h-2 w-2 rounded-full bg-cyan-400" />
                    </span>
                  </div>
                  <h3 className="font-display text-2xl font-bold text-white">{p.title}</h3>
                  <p className="mt-3 text-slate-400 text-[14px] leading-relaxed">{p.copy}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
